import {
  addMessageSuccess,
  createSessionSuccess,
  deleteFeedbackSuccess,
  deleteSessionSuccess,
  getAllFeedbackFailure,
  getAllFeedbackRequest,
  getAllFeedbackSuccess,
  getSessionMessagesFailure,
  getSessionMessagesInitiate,
  getSessionMessagesSuccess,
  getSessionsFailure,
  getSessionsInitiate,
  getSessionsSuccess,
  recordFeedbackSuccess,
  resetSessionMessagesSuccess,
  setSelectedSessionSuccess,
  updateMessageSuccess,
  updateSessionSuccess,
  updateFeedbackSuccess,
} from "../events/sessionEvents";
import sessionService from "../api/sessionService";

export function setSelectedSession(session) {
  return (dispatch) => {
    dispatch(setSelectedSessionSuccess(session));
  };
}

export function createSession(domainId = "", chatMode = "", fileId = "") {
  return async (dispatch) => {
    try {
      const response = await sessionService.createSession(
        domainId,
        chatMode,
        fileId
      );
      dispatch(createSessionSuccess({ ...response, title: "New Session" }));
      return response;
    } catch (error) {
      throw error;
    }
  };
}

export function updateSession(session) {
  return async (dispatch) => {
    try {
      await sessionService.updateSession(session);
      dispatch(updateSessionSuccess(session));
    } catch (error) {
      throw error;
    }
  };
}

export function deleteSession(sessionId) {
  return async (dispatch) => {
    try {
      await sessionService.deleteSession(sessionId);
      dispatch(deleteSessionSuccess(sessionId));
    } catch (error) {
      throw error;
    }
  };
}

export function getAllSessions(domainId = "") {
  return async (dispatch) => {
    try {
      dispatch(getSessionsInitiate());
      const response = await sessionService.getAllSessions(domainId);
      const conversations = response["conversations"] || [];
      const sortedConversations = [...conversations].sort(
        (item1, item2) =>
          Date.parse(item2["updated_at"]) - Date.parse(item1["updated_at"])
      );
      dispatch(getSessionsSuccess(sortedConversations));
      return sortedConversations;
    } catch (error) {
      dispatch(getSessionsFailure());
      throw error;
    }
  };
}

export function getSessionMessages(sessionId) {
  return async (dispatch) => {
    try {
      dispatch(getSessionMessagesInitiate());
      const response = await sessionService.getSessionMessages(sessionId);
      return response;
    } catch (error) {
      dispatch(getSessionMessagesFailure());
      throw error;
    }
  };
}

export function recordFeeback(messageId, feedbackData) {
  return async (dispatch) => {
    try {
      await sessionService.recordFeedback(messageId, feedbackData);
      dispatch(recordFeedbackSuccess(feedbackData));
    } catch (error) {
      throw error;
    }
  };
}

export function updateFeedback(messageId, feedbackData) {
  return async (dispatch) => {
    try {
      await sessionService.updateFeedback(messageId, feedbackData);
      dispatch(updateFeedbackSuccess(feedbackData));
    } catch (error) {
      throw error;
    }
  };
}

export function deleteFeedback(messageId) {
  return async (dispatch) => {
    try {
      await sessionService.deleteFeedback(messageId);
      dispatch(deleteFeedbackSuccess(messageId));
    } catch (error) {
      throw error;
    }
  };
}

export function getAllFeedback(domainId) {
  return async (dispatch) => {
    try {
      dispatch(getAllFeedbackRequest());
      const response = await sessionService.getAllFeedback(domainId);
      dispatch(getAllFeedbackSuccess(response.feedback_reports));
      return response;
    } catch (error) {
      const serializedError = {
        message: error.message || "Unknown error",
        status: error.response?.status || "No status",
        statusText: error.response?.statusText || "No status text",
      };
      dispatch(getAllFeedbackFailure(serializedError));
      throw error;
    }
  };
}

export async function getPromptQuestions() {
  try {
    const response = await sessionService.getPromptQuestions();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getPipelineLogs(questionId) {
  try {
    const response = await sessionService.getPipelineLogs(questionId);
    return response;
  } catch (error) {
    throw error;
  }
}

export function getImage(imageURL) {
  return async (dispatch) => {
    try {
      const response = await sessionService.getImage(imageURL);
      return response;
    } catch (error) {
      throw error;
    }
  };
}

export function bookmarkOrUnmarkMessage(message) {
  return async (dispatch) => {
    try {
      await sessionService.bookmarkOrUnmarkMessage(message["query"]);
      dispatch(updateMessageSuccess(message));
    } catch (error) {
      throw error;
    }
  };
}

export function getBookmarkedMessages(domainId) {
  return async (dispatch) => {
    try {
      const response = await sessionService.getBookmarkedMessages(domainId);
      return response;
    } catch (error) {
      throw error;
    }
  };
}

export function getCitations(citationId) {
  return async (dispatch) => {
    try {
      const response = await sessionService.getCitations(citationId);
      return response;
    } catch (error) {
      throw error;
    }
  };
}

export function getRelatedDocs(query, domainId, questionId, conversationId) {
  return async (dispatch) => {
    try {
      const response = await sessionService.getRelatedDocs(query, domainId, questionId, conversationId);
      return response;
    } catch (error) {
      throw error;
    }
  };
}
